import './style.less';

export default function($log, $stateParams) {
  'ngInject';

  const vm = this;
  this.$onInit = activate;

  function activate() {
    $log.debug('Users upsell controller activated');

    vm.product = $stateParams.product;
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/upgrade/index.js